import * as React from 'react'

export interface InputIconProps extends React.ComponentPropsWithRef<'div'> {
  icon?: React.ElementType
  children?: React.ReactNode
  size?: number | string
  color?: string
}

export const InputIcon = ({
  icon: Icon,
  size = 20,
  color,
  children,
}: InputIconProps) => {
  return (
    <div className="input-icon">
      {Icon ? <Icon size={size} color={color} /> : children}
    </div>
  )
}
